import getAdjustedDate from "./getAdjustedDate"

export default function getFormattedDate({ date, options }) {
	if (!date) return null
	if (!options) options = { year: "numeric", month: "short", day: "2-digit" }
	// console.log("getFormattedDate, Date = ",date)
	date = getAdjustedDate({ date })
	// console.log("getFormattedDate, Adjusted Date = ",date)
	const formattedDate = date.toLocaleString("en", options)

	return formattedDate
}
